import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { AffiliationsSection } from '../AffiliationsSection.js';
import { BasicsSection } from '../BasicsSection.js';
import { PhysicalAttributesSection } from '../PhysicalAttributesSection.js';
import { TitlesSection } from '../TitlesSection.js';
export function OverviewTab(props) {
    const { character, currentDate, canEdit } = props;
    return (_jsxs(Stack, { spacing: 3, children: [_jsx(BasicsSection, { character: character, currentDate: currentDate, canEdit: canEdit }), _jsx(TitlesSection, { character: character, canEdit: canEdit }), _jsx(AffiliationsSection, { character: character, canEdit: canEdit }), _jsx(PhysicalAttributesSection, { character: character, canEdit: canEdit })] }));
}
//# sourceMappingURL=OverviewTab.js.map